export default __webpack_public_path__ + "static/media/BurfordRusticLine-Regular2.86784de9.otf";